const ru = {
  nav_timeline: "Хронология",
  nav_invest: "Инвестировать",
  nav_technology: "Технологии",
  nav_roadmap: "Дорожная карта",
  nav_join: "Присоединиться",
  hero_badge: "Согласовано с дорожной картой миссии Артемида",
  hero_title_1: "Инвестиции в",
  hero_title_2: "Будущее Лунной",
  hero_title_3: "Цивилизации",
  hero_subtitle: "ARTEMIDA — частная инициатива, поддерживающая следующее поколение лунной инфраструктуры в рамках глобальной дорожной карты миссии Артемида.",
  hero_cta_join: "Присоединиться к ранним инвесторам",
  hero_cta_whitepaper: "Скачать Whitepaper",
  hero_stat_1_label: "Веха миссии",
  hero_stat_2_label: "Фазы развития",
  hero_stat_3_label: "Орбитальная энергетика",
  hero_scroll: "Прокрутите",
  timeline_badge: "Фазы миссии",
  timeline_title: "Хронология проекта",
  timeline_subtitle: "Четыре стратегические фазы, ведущие к постоянной лунной экономике и орбитальной энергетической сети.",
  phase1_name: "ARTEMIDA II",
  phase1_year: "Завершена 2026",
  phase1_title: "Пилотируемая лунная орбита",
  phase1_desc: "Достигнута веха пилотируемой лунной орбитальной миссии. Первый успешный пилотируемый выход на лунную орбиту в рамках частной инициативы ARTEMIDA.",
  phase2_name: "ARTEMIDA III",
  phase2_year: "2027",
  phase2_title: "Лунная поверхностная логистика",
  phase2_desc: "Подготовительный этап инфраструктуры лунной поверхностной логистики. Развёртывание автономных грузовых систем и навигационных маяков.",
  phase3_name: "ARTEMIDA IV",
  phase3_year: "2028",
  phase3_title: "Постоянное лунное присутствие",
  phase3_desc: "Начало постоянного лунного присутствия и систем поддержки развёртывания базы. Строительство модульных жилищ с системами жизнеобеспечения.",
  phase4_name: "Орбитальная солнечная сеть",
  phase4_year: "2030+",
  phase4_title: "Космическая солнечная инфраструктура",
  phase4_desc: "Разработка космической солнечной инфраструктуры для поддержки долгосрочного финансирования лунной экономики.",
  status_completed: "Завершена",
  status_active: "В процессе",
  status_upcoming: "Предстоит",
  invest_badge: "Инвестиционный кейс",
  invest_title_1: "Почему инвестировать в",
  invest_subtitle: "Лунная экономика — не далёкая концепция, она строится прямо сейчас. ARTEMIDA предлагает редкую точку входа в инфраструктурный слой расширения человечества за пределы Земли.",
  invest_global: "Глобальное согласование с Артемидой",
  invest_global_sub: "Партнёрство с международными космическими агентствами и частными операторами",
  reason1_title: "Поддержка лунной инфраструктуры",
  reason1_desc: "Напрямую финансируйте физическую основу следующего рубежа человечества — от поверхностной логистики до орбитальных ретрансляционных систем.",
  reason2_title: "Рост космической экономики",
  reason2_desc: "Участвуйте в самом быстрорастущем секторе мировой экономики. Ожидается, что космическая отрасль превысит $1 трлн к 2040 году.",
  reason3_title: "Ранний доступ к экосистеме",
  reason3_desc: "Получите ранний доступ к будущей экосистеме орбитальной энергетической сети — позиционируя портфель на пересечении чистой энергии и космической инфраструктуры.",
  reason4_title: "Стратегическое аэрокосмическое позиционирование",
  reason4_desc: "Обеспечьте стратегическое позиционирование в инновациях аэрокосмической отрасли следующего поколения. ARTEMIDA сотрудничает с глобальными институтами.",
  funding_badge: "Структура капитала",
  funding_title: "Стратегия финансирования",
  funding_subtitle: "Инициатива ARTEMIDA согласована с будущими крупномасштабными аэрокосмическими финансовыми моделями и партнёрствами с глобальными институтами и частными космическими компаниями.",
  funding_metric1_label: "Целевой сбор",
  funding_metric1_sub: "Серии A и B вместе",
  funding_metric2_label: "Стратегических партнёров",
  funding_metric2_sub: "Глобальные институты",
  funding_metric3_label: "Инфраструктурное распределение",
  funding_metric3_sub: "Прямые лунные активы",
  funding_metric4_label: "Горизонт доходов",
  funding_metric4_sub: "Продажи орбитальной энергии",
  funding_alloc_title: "Модель распределения капитала",
  funding_alloc1: "Лунная инфраструктура",
  funding_alloc2: "Орбитальная солнечная разработка",
  funding_alloc3: "Логистика и операции",
  funding_alloc4: "НИОКР и инновации",
  funding_partners: "Партнёры и соавторы экосистемы",
  partner1: "Космические агентства",
  partner2: "Глобальные институты",
  partner3: "Частные космические компании",
  partner4: "Венчурный капитал",
  partner5: "Орбитальные операторы",
  partner6: "Технологические партнёры",
  tech_badge: "Основные системы",
  tech_title: "Технологическое видение",
  tech_subtitle: "Четыре столпа технологической экосистемы ARTEMIDA, разработанные для долгосрочной лунной экономики.",
  tech1_title: "Космические солнечные массивы",
  tech1_desc: "Массивные фотовольтаические массивы на геостационарной орбите, улавливающие непрерывную солнечную энергию и передающие её через микроволновые лучи.",
  tech1_s1: "99.9% доступность",
  tech1_s2: "Мощность ГВт-масштаба",
  tech1_s3: "Микроволновая передача",
  tech2_title: "Орбитальные логистические системы",
  tech2_desc: "Автономные орбитальные транспортные средства и склады снабжения, формирующие постоянный цислунарный коридор для регулярных перевозок.",
  tech2_s1: "Автономные операции",
  tech2_s2: "Многоразовые аппараты",
  tech2_s3: "72ч транзит Земля-Луна",
  tech3_title: "Лунная поддерживающая инфраструктура",
  tech3_desc: "Модульные герметичные жилища, системы строительства на основе реголита и автономные наземные транспортные средства.",
  tech3_s1: "Строительство из реголита",
  tech3_s2: "Модульные жилища",
  tech3_s3: "Автономные роверы",
  tech4_title: "Рамка космической экономики",
  tech4_desc: "Экономический слой следующего поколения, интегрирующий токенизированные права на ресурсы, торговлю орбитальной энергией и децентрализованное управление.",
  tech4_s1: "Токенизированные активы",
  tech4_s2: "Торговля энергией",
  tech4_s3: "DAO управление",
  roadmap_badge: "Стратегическая хронология",
  roadmap_title: "Дорожная карта",
  roadmap_subtitle: "Чёткий путь от орбитальной вехи до полноценной лунной экономики — построенный на подтверждённом прогрессе.",
  rm1_title: "Достигнута веха орбитальной миссии",
  rm1_detail: "ARTEMIDA II успешно завершает пилотируемую лунную орбиту. Архитектура миссии подтверждена. Доверие инвесторов обеспечено.",
  rm2_title: "Подготовительный этап лунной миссии",
  rm2_detail: "ARTEMIDA III начинает подготовку поверхностной логистики. Развёрнуты автономные грузовые системы. Установлена сеть маяков.",
  rm3_title: "Фаза расширения лунной инфраструктуры",
  rm3_detail: "ARTEMIDA IV инициирует постоянное развёртывание базы. Начинаются модульные жилища, энергосистемы и поверхностные операции.",
  rm4_title: "Стратегия масштабирования орбитальной солнечной энергии",
  rm4_detail: "Полное развёртывание космических солнечных массивов. Начинается торговля орбитальной энергией. Лунная экономика достигает самодостаточного порога.",
  token_badge: "Токеномика",
  token_title: "Полезность токена",
  token_subtitle: "Токен ARTEMIDA — экономический хребет экосистемы лунной инфраструктуры, обеспечивающий доступ, управление и рост.",
  token1_title: "Доступ к услугам экосистемы",
  token1_desc: "Держатели токенов получают приоритетный доступ к услугам платформы ARTEMIDA, орбитальным потокам данных и правам использования лунной инфраструктуры.",
  token2_title: "Участие в управлении",
  token2_desc: "Голосуйте по ключевым решениям проекта, включая приоритеты миссии, распределение капитала и одобрение партнёрств.",
  token3_title: "Слой финансирования инфраструктуры",
  token3_desc: "Токены служат основным инструментом финансирования лунных и орбитальных инфраструктурных проектов с пропорциональной доходностью.",
  token4_title: "Интеграция в космическую экономику",
  token4_desc: "Бесшовно интегрирован в развивающуюся цислунарную экономику — обеспечивая торговлю энергией, права на ресурсы и кросс-платформенную совместимость.",
  token_supply: "Общее предложение: <strong>1 000 000 000 ARTM</strong> — распределено между финансированием инфраструктуры, наградами экосистемы, вестингом команды и публичной продажей.",
  cta_badge: "Ранний доступ",
  cta_title_1: "Присоединитесь к ARTEMIDA",
  cta_title_2: "Программа ранних сторонников",
  cta_subtitle: "Обеспечьте своё место в первой волне инвесторов в лунную инфраструктуру. Ограниченное количество слотов раннего доступа.",
  form_join_title: "Присоединиться к ранним инвесторам",
  form_first_name: "Имя",
  form_last_name: "Фамилия",
  form_email: "Email",
  form_org: "Организация",
  form_org_placeholder: "Фонд / Компания",
  form_interest: "Инвестиционный интерес",
  form_interest_placeholder: "Выберите диапазон",
  form_message: "Сообщение (необязательно)",
  form_message_placeholder: "Расскажите о вашей инвестиционной стратегии...",
  form_submit_join: "Подать заявку на ранний доступ",
  form_submitting: "Отправка...",
  form_success_join_title: "Заявка получена",
  form_success_join_sub: "Наша команда свяжется с вами в течение 48 часов.",
  form_wp_title: "Скачать Whitepaper",
  form_full_name: "Полное имя",
  form_full_name_placeholder: "Ваше полное имя",
  form_email_placeholder: "ваш@email.com",
  form_role: "Роль",
  form_role_placeholder: "Выберите вашу роль",
  form_role_investor: "Инвестор",
  form_role_analyst: "Аналитик / Исследователь",
  form_role_media: "СМИ / Пресса",
  form_role_partner: "Потенциальный партнёр",
  form_role_other: "Другое",
  form_country: "Страна",
  form_country_placeholder: "Россия",
  form_wp_file: "ARTEMIDA Whitepaper v2.1",
  form_wp_file_sub: "48 стр. · PDF · 12.4 МБ",
  form_submit_wp: "Запросить Whitepaper",
  form_success_wp_title: "Whitepaper отправлен",
  form_success_wp_sub: "Проверьте входящую почту для получения whitepaper ARTEMIDA.",
  // Reviews
  reviews_badge: "Отзывы клиентов",
  reviews_title: "Что говорят инвесторы",
  reviews_subtitle: "Реальные отзывы клиентов из разных стран, получивших свои выплаты.",
  reviews_verified: "Верифицирован",
  reviews_stat1: "Довольных клиентов",
  reviews_stat2: "Дня до выплаты",
  reviews_stat3: "Успешных контрактов",

  // Calculator
  calc_badge: "Калькулятор прибыли",
  calc_title: "Рассчитай свою прибыль",
  calc_subtitle: "Выберите контракт или введите свою сумму и узнайте точную выплату за 3 рабочих дня.",
  calc_select_contract: "Выберите контракт",
  calc_custom_amount: "Или введите свою сумму",
  calc_custom_placeholder: "Напр. 45000",
  calc_custom_note: "Доходность рассчитывается по условиям выбранного контракта",
  calc_payout_label: "Выплата за 3 рабочих дня",
  calc_payout_desc: "Средства переводятся автоматически после завершения контракта",
  calc_your_investment: "Ваша инвестиция",
  calc_yield_label: "доходность",
  calc_initial: "Начальная сумма",
  calc_profit: "Прибыль",
  calc_total_payout: "Итого к выплате",
  calc_days_note: "Выплата в течение 3 рабочих дней после запуска контракта",
  calc_stat_days: "Рабочих дня",
  calc_stat_yield: "Доходность",
  calc_stat_currency: "Валюта",
  calc_min_amount: "Минимальная сумма",
  livefeed_received: "получил выплату",

  // Contracts Section
  contract_badge: "Условия инвестирования",
  contract_title_1: "Финансовые",
  contract_title_2: "Контракты участия",
  contract_subtitle: "ARTEMIDA предлагает структурированные инвестиционные контракты, обеспеченные операционным капиталом SpaceX. Выберите свой тир и получите выплату в течение 3 рабочих дней.",
  contract_collateral_title: "Залоговая и кредитная структура",
  contract_collateral_sub: "SpaceX управляет залоговой структурой и кредитным механизмом инициативы",
  contract_collateral_amount: "Залоговая сумма",
  contract_credit_amount: "Кредитная линия",
  contract_operator: "Оператор",
  contract_popular: "Популярный",
  contract_tier_entry: "Начальный",
  contract_tier_growth: "Рост",
  contract_tier_premium: "Премиум",
  contract_investment: "Инвестиция",
  contract_yield: "Доходность",
  contract_return: "Прибыль",
  contract_total: "Итого к выплате",
  contract_payout: "Срок выплаты",
  contract_days: "рабочих дня",
  contract_select: "Выбрать контракт",
  contract_disclaimer: "Все контракты являются концептуальными инвестиционными инструментами в рамках инициативы ARTEMIDA. Инвестирование в космическую инфраструктуру сопряжено со значительным риском. Прошлые результаты не гарантируют будущих доходов.",
  contract_modal_title: "Детали контракта",
  contract_modal_desc: "Для участия в данном инвестиционном контракте свяжитесь с нашей командой через форму для ранних инвесторов ниже.",
  contract_modal_note: "Все контракты подлежат верификации личности и соответствию применимому законодательству.",
  contract_modal_close: "Понятно",

  // SpaceX Section
  spx_badge: "Стратегическое партнёрство",
  spx_title_1: "Согласовано с видением",
  spx_title_2: "SpaceX & Илона Маска",
  spx_subtitle: "ARTEMIDA напрямую позиционирована в орбитальной солнечной стратегии SpaceX. Илон Маск объявил цель в 100 гигаватт орбитальной солнечной мощности в течение 30 месяцев — ARTEMIDA является инфраструктурным слоем, поддерживающим эту революцию.",
  spx_stat1_label: "Целевая мощность SpaceX",
  spx_stat1_sub: "Ежегодное производство солнечной энергии в орбите к концу 2028 г.",
  spx_stat2_label: "Выше КПД в орбите",
  spx_stat2_sub: "Космические солнечные станции производят в 5 раз больше энергии, чем наземные",
  spx_stat3_label: "Месяцев до развёртывания",
  spx_stat3_sub: "Маск: орбитальная солнечная энергия станет наиболее рентабельной в течение 30 месяцев",
  spx_stat4_label: "Время работы в орбите",
  spx_stat4_sub: "Без ночи, без облаков — непрерывный захват солнечной энергии 24/7",
  spx_quote: "В течение 30 месяцев космическая солнечная энергия станет наиболее рентабельным методом производства энергии. Starship может доставить 300–500 ГВт солнечных спутников на орбиту ежегодно.",
  spx_intro: "SpaceX и Tesla работают над производством 100 ГВт солнечных элементов в год. Starship, несущий 200 тонн за полёт, развернёт массивные орбитальные солнечные массивы — напрямую питающие лунную инфраструктуру ARTEMIDA и центры обработки данных ИИ на Земле.",
  spx_fact1_title: "Starship — двигатель развёртывания",
  spx_fact1_desc: "Starship несёт 200 тонн за полёт и может доставить 300–500 ГВт солнечных спутников на орбиту ежегодно. Стоимость запуска падает до $100–200/кг, делая орбитальные солнечные станции мощностью 10 ГВт финансово жизнеспособными.",
  spx_fact2_title: "×5 КПД: Физика орбитальной энергии",
  spx_fact2_desc: "На орбите солнечные панели захватывают энергию 99% времени — без ночи, без облаков, без атмосферного рассеивания. Солнечная интенсивность на 40% выше, а годовой выход до 13 раз больше, чем у наземной установки.",
  spx_fact3_title: "100 ГВт к концу 2028 г.",
  spx_fact3_sub: "Маск объявил на ВЭФ 2026, что SpaceX и Tesla независимо работают над созданием 100 ГВт годового производственного мощности солнечных элементов в США.",
  spx_fact3_desc: "Маск объявил на Всемирном экономическом форуме 2026, что SpaceX и Tesla независимо работают над созданием 100 ГВт годового производственного мощности солнечных элементов в США — для питания ИИ и лунной инфраструктуры.",
  spx_compare_title: "Эффективность: Наземная vs. Орбитальная солнечная энергия",
  spx_compare_ground: "Наземная солнечная станция",
  spx_compare_orbit: "Орбитальная солнечная станция (SpaceX)",
  spx_compare_note: "Орбитальные солнечные станции генерируют до 13 раз больше энергии в год, чем идентичная наземная установка, благодаря непрерывному воздействию и отсутствию атмосферного рассеивания. Стоимость: ~3.8 цента/кВтч при зрелости.",

  footer_tagline: "Космические инновации | Лунная инфраструктура | Будущее орбитальной энергетики",
  footer_rights: "© 2026 ARTEMIDA Initiative. Все права защищены.",
  footer_disclaimer: "Этот сайт предназначен только для информационных целей и не является финансовым советом или предложением о продаже ценных бумаг. Инвестиции в космическую инфраструктуру сопряжены со значительным риском.",
};

export default ru;
